import PropTypes from "prop-types";
import useMatchMedia from "../../../../useMatchMedia";
import ProductImage from "../../../../ProductImage";
import LazyProductHero from "../../../../LazyProductHero";
import {
  ImageGalleryWithPreview,
  ImageGalleryWithoutPreview
} from "../../../../__variants__/saved-lists-mweb-image-gallery/shown/ImageGallery";
import ProductTileBanners from "../../../../ProductTileBanners";

const getGalleryComponent = ({ index }) => {
  if (index === 0) {
    return ImageGalleryWithPreview;
  }

  return ImageGalleryWithoutPreview;
};

const getImageComponent = ({
  prefersReducedMotion,
  hasAdditionalImages,
  supportsHover,
  index
}) => {
  if (prefersReducedMotion || !hasAdditionalImages || supportsHover) {
    return ProductImage;
  }

  return getGalleryComponent({ index });
};

const ProductHero = ({ additionalImageUrls, index, ...rest }) => {
  const prefersReducedMotion = useMatchMedia("(prefers-reduced-motion)");
  const hasAdditionalImages = additionalImageUrls.length > 0;
  const supportsHover = useMatchMedia("(hover: hover)");
  const ImageComponent = getImageComponent({
    prefersReducedMotion,
    hasAdditionalImages,
    supportsHover,
    index
  });

  return (
    <LazyProductHero
      {...{
        additionalImageUrls,
        render: lazyProps => (
          <ImageComponent {...{ additionalImageUrls, ...rest, ...lazyProps }} />
        ),
        ...rest
      }}
    >
      <ProductTileBanners {...rest} />
    </LazyProductHero>
  );
};

ProductHero.propTypes = {
  index: PropTypes.number.isRequired,
  showVideo: PropTypes.bool,
  additionalImageUrls: PropTypes.arrayOf(PropTypes.string)
};

export default ProductHero;
